/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SubmissionQueryResult from './SubmissionQueryResult';

/**
 * The SubmissionOutputCmsSubmissions model module.
 * @module model/SubmissionOutputCmsSubmissions
 * @version 1.0
 */
class SubmissionOutputCmsSubmissions {
    /**
     * Constructs a new <code>SubmissionOutputCmsSubmissions</code>.
     * @alias module:model/SubmissionOutputCmsSubmissions
     */
    constructor() { 
        
        SubmissionOutputCmsSubmissions.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SubmissionOutputCmsSubmissions</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SubmissionOutputCmsSubmissions} obj Optional instance to populate.
     * @return {module:model/SubmissionOutputCmsSubmissions} The populated <code>SubmissionOutputCmsSubmissions</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SubmissionOutputCmsSubmissions();

            if (data.hasOwnProperty('submissions')) {
                obj['submissions'] = ApiClient.convertToType(data['submissions'], [SubmissionQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/SubmissionQueryResult>} submissions
 */
SubmissionOutputCmsSubmissions.prototype['submissions'] = undefined;






export default SubmissionOutputCmsSubmissions;

